<template lang="pug">
  .modal-card
    header.modal-card-head
      p.modal-card-title Delete this Reseller?
      button.delete(@click="$emit('close')")
    section.modal-card-body
      p.message-text Any programs linked to this reseller will become unavailable.
      p.message-text This action cannot be undone.
    footer.modal-card-foot
      WtButton.cancel-btn(
        @click.native="$emit('close')"
      )
        | Cancel
      WtButton.delete-btn(
        @click.native="submit"
        :loading="loading"
        :disabled="loading"
      )
        | Delete
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";

export default {
  name: "DeleteResellerConfirmDialog",

  components: { WtButton },

  props: {
    reseller: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    submit() {
      this.$emit("confirm", this.reseller);
    }
  }
};
</script>

<style lang="sass" scoped>
.modal-card
  max-width: 455px

.modal-card-head
  padding: 20px 16px
  border-bottom: 1px solid #E5E5E5

.modal-card-title
  font-weight: 600
  font-size: 18px
  line-height: 28px
  margin: 0
  color: #1B1D20

.modal-card-body
  padding: 20px 16px
  display: flex
  flex-direction: column
  gap: 16px

  .message-text
    font-family: Manrope
    font-weight: 400
    font-size: 15px
    line-height: 23px
    color: #1B1D20
    margin: 0

.modal-card-foot
  padding: 12px 16px
  gap: 10px
  display: flex
  justify-content: flex-end
  border-top: 1px solid #E5E5E5

  ::v-deep .wt-button
    font-weight: 600
    font-size: 16px
    line-height: 24px
    border-radius: 10px
    padding: 8px 24px !important
    height: 40px
    display: flex
    align-items: center
    justify-content: center

    &.cancel-btn
      background-color: #FFFFFF !important
      color: #2972F0 !important
      border: 1px solid #2972F0 !important

      &:hover:not(:disabled)
        opacity: 0.95

      &:active:not(:disabled)
        opacity: 0.9

    &.delete-btn
      background-color: #2972F0 !important
      color: #FFFFFF !important
      border: none !important

      &:hover:not(:disabled)
        opacity: 0.95

      &:active:not(:disabled)
        opacity: 0.9

    &:disabled
      opacity: 0.6
      cursor: not-allowed
</style>
